type BtnTerminarProps ={
    txtBtn:string ,    
    id?:number,
    execFunc:() => void,
    disabledBtn?:boolean
  }


const BtnTerminar = ({txtBtn,id=0,execFunc,disabledBtn=false}:BtnTerminarProps) => {
  return (
    <>
    { disabledBtn ? 
     <button
     className="performCol_botonInactive"
     disabled             
     >   
    <div className="alineacionBoton">  
      {/* <img src={AddIcon} alt="" /> */}
        <div className="nombrePrestacion">
           <b><span>{txtBtn}</span> </b>
          </div>
    </div>
   </button>
   :
    <button
    id="addPrestacion"     
    onClick={execFunc}
    className="btnNuevaPrestacion"
      >
      <div className="alineacionBoton">
        {/* <img src={AddIcon} alt="" /> */}
        <div className="nombrePrestacion">
          <b><span>{txtBtn}</span> </b>
        </div>
      </div>
    </button>   
   }
    </>
  )
}

export default BtnTerminar